import styled from "styled-components";

export const RabbitFestivalRankTop3Wrapper = styled.div`
  padding-top: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const RabbitFestivalRankTop3Item = styled.div<{ rank: number }>`
  position: relative;
  top: ${(p) => (p.rank === 1 ? "0" : "30px")};
  min-width: 105px;
`;

export const FestivalRankTop3ImageWrapper = styled.div<{ rank: number }>`
  position: relative;
  width: 100%;
  height: 110px;

  > .rank {
    position: absolute;
    top: 80px;
    right: -45px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index: 2;

    > img {
      width: 40px;
      height: 40px;
    }
  }
`;

export const FestivalRankTop3Back = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 135px;
  height: 135px;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  > .back {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 135px;
    height: 135px;
  }

  > .profile {
    width: calc(100% - 45px);
    height: calc(100% - 36px);
    object-fit: cover;
    margin-bottom: 3px;
    padding-left: 3px;
    /* 육각형 clip-path (정확한 좌표로 정형화) */
    clip-path: polygon(50% 0%, 100% 23%, 100% 78%, 50% 100%, 0% 78%, 0% 23%);
    border-radius: 3px;
  }
`;

export const RabbitFestivalRankTop3ItemText = styled.div`
  display: flex;
  flex-direction: column;
  color: #000;
  align-items: center;
  padding-top: 20px;
  gap: 2px;

  > .pub {
    font-weight: 500;
    font-size: 10px;
  }

  > .nickname {
    border-radius: 8px;
    padding: 2px 12px;
    background: #00000040;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    max-width: 90px;
    box-sizing: border-box;
  }

  > .point {
    font-weight: 700;
    font-size: 14px;
    margin-top: 4px;
  }
`;
